/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, Renderer2, inject } from '@angular/core';
import { NgfA11yService } from '@ng-falcon/ngf-a11y/ngf-a11y.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'a[ngfLink],button[ngfLink]',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class LinkComponent implements OnInit {

  @Input('ngfLink')
  variant: '' | 'danger' | 'sidenav';

  readonly elementRef: ElementRef<HTMLElement> = inject(ElementRef)
  private renderer: Renderer2 = inject(Renderer2)
  private a11y: NgfA11yService = inject(NgfA11yService)

  ngOnInit(): void {
    this.a11y.prepareClickableElement(this.elementRef, this.renderer);
  }

}
